import { ReactNode } from 'react';

export const PURCHASE_REPORT_PAGE_SIZE = 50;

export const PURCHASE_STATUSES = ['', 'Unpaid', 'Partially Paid', 'Paid'];

export interface PaginatedReportResponse<T = Record<string, unknown>> {
  rows: T[];
  total: number;
  page: number;
  page_size: number;
  summary?: Record<string, unknown>;
}

export interface ReportColumn<T> {
  id: string;
  header: string;
  accessorKey?: keyof T & string;
  cell?: (row: T) => ReactNode;
  align?: 'left' | 'right';
  exportValue?: (row: T) => string | number;
}

export interface SummaryCardItem {
  label: string;
  value: string | number;
  tone?: 'default' | 'success' | 'warning' | 'danger';
}

export interface SupplierOption {
  name: string;
  supplier_name: string;
  mobile?: string;
}
